import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import { DjayAvatar, useDjaySelection } from '../../mascot';
import { humanizeFamilyId } from '../../content';
import { getEnabledModes } from '../../modes';
import { tapSpring, hoverLift } from '../../components/shared/motionPresets';
import { soundManager } from '../../utils/soundManager';
import { hapticManager } from '../../utils/hapticManager';
interface ContinueStripProps {
  modeId: string;
  familyId?: string;
  score?: number;
  timestamp: number;
  onContinue: () => void;
}
export function ContinueStrip({
  modeId,
  familyId,
  score,
  timestamp,
  onContinue
}: ContinueStripProps) {
  const {
    selectedVariant
  } = useDjaySelection();
  const mode = getEnabledModes().find(m => m.id === modeId);
  if (!mode) return null;
  const handleClick = () => {
    soundManager.playClick();
    hapticManager.hapticLight();
    onContinue();
  };
  return <motion.button onClick={handleClick} {...tapSpring} {...hoverLift} className="w-full bg-white rounded-2xl p-3 sm:p-4 shadow-sm border border-slate-200 flex items-center gap-4 group text-left" data-id="element-2818">
      <div className="flex-shrink-0 w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center border border-slate-100" data-id="element-2819">
        <DjayAvatar size="sm" emotion="encouraging" variant={selectedVariant} animate={false} data-id="element-2820" />
      </div>

      <div className="flex-1 min-w-0" data-id="element-2821">
        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-2822">
          Verder waar je was
        </div>
        <div className="text-sm font-bold text-slate-800 truncate" data-id="element-2823">
          {mode.title}
          {familyId && <span className="text-slate-500 font-medium" data-id="element-2824">
              {' '}
              — {humanizeFamilyId(familyId)}
            </span>}
        </div>
        {score !== undefined && <div className="text-xs text-slate-500 mt-0.5" data-id="element-2825">
            Vorige score:{' '}
            <span className="font-bold text-slate-700" data-id="element-2826">{score}%</span>
          </div>}
      </div>

      <div className="flex-shrink-0 flex items-center gap-2 text-indigo-600" data-id="element-2827">
        <span className="text-xs font-bold hidden sm:inline-block" data-id="element-2828">
          Doorgaan
        </span>
        <div className="w-8 h-8 rounded-full bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100 transition-colors" data-id="element-2829">
          <ArrowRight className="w-4 h-4" data-id="element-2830" />
        </div>
      </div>
    </motion.button>;
}